const location = document.location;
export const BaseUrl = location.protocol + "//" + location.host;
export const ApiUrl = "https://admin.retailcart.com.au";
export const StripeKey = "pk_live_w7Du4wlQAuKXQmdzNcPHJeMt00oiyZTWXF";
